
<template>
  <div class='btn'
       :style="{'width':width,'height':height}"
       :class="{down:isDown}"
       @mousedown="isDown = true"
       @mouseup="isDown = false"
       @mouseleave="isDown=false"
       @click="click">{{ text }}</div>
</template>

<script>

export default {
  name: 'GButton',
  components: {},
  props: {
    text: { type: String, default: '按钮' },
    width: String,
    height: String
  },
  data () {
    return {
      isDown: false

    }
  },
  computed: {},
  watch: {},
  // 方法集合
  methods: {
    click () {
      this.$emit('click')
    }
  },
  created () {

  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.btn {
  display: flex;
  color: white;
  user-select: none;
  background-color: $color-primary;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
    background-color: #497aff;
  }
}
.down {
  background-color: #2c5de3 !important;
}
</style>
